var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showAnimationLocationVerified,
          expression: "showAnimationLocationVerified"
        }
      ],
      staticClass: "gc-dialogs"
    },
    [
      _c("v-flex", { attrs: { persistent: "" } }, [
        _c("div", { staticClass: "checkmark-wrapper" }, [
          _c(
            "svg",
            {
              staticClass: "checkmark",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 52 52"
              }
            },
            [
              _c("circle", {
                staticClass: "checkmark__circle",
                attrs: { cx: "26", cy: "26", r: "25", fill: "none" }
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "checkmark__check",
                attrs: { fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8" }
              })
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("Geolocation.Location.Verified")))])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52529441", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52529441","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CheckMark.vue
// module id = null
// module chunks = 